import PropTypes from 'prop-types';
import React from 'react';

import BrandfolderList from '../BrandfolderList/BrandfolderList';
import './OrganizationList.css';

class OrganizationList extends React.Component {
  static propTypes = {
    containers: PropTypes.array,
    onClick: PropTypes.func.isRequired,
    organizations: PropTypes.array
  };

  render() {
    return (
      <div className="organization-list">
        {this.props.organizations &&
          this.props.organizations.map(organization => (
            <div className="organization" key={organization.id}>
              <h2>{organization.attributes.name}</h2>
              <BrandfolderList
                containers={this.getContainersForOrganization(organization)}
                onClick={this.props.onClick.bind(this)}
              />
            </div>
          ))}
      </div>
    );
  }

  getContainersForOrganization(organization) {
    return this.props.containers.filter(
      containers => containers.organization && containers.organization.id === organization.id
    );
  }
}

export default OrganizationList;



// WEBPACK FOOTER //
// ./src/components/OrganizationList/OrganizationList.js